import { SearchContext } from 'common/src/elasticSearch/types'
import { CancelToken } from 'axios'
import {
    CFSearchResponse,
    FindSimilarNotecardsResponse,
} from 'common/src/elasticSearch/responses'
import { APIResponseWrapper, CB_BASE_PREFIX } from '@/api/types'
import { callBackend } from '@/api/callBackend'
import {
    CBSearchRequest,
    FindSimilarNotecardsRequest,
} from 'common/src/elasticSearch/requests'
import { ApiMethod } from 'common/src/api/types'
import { GenerateNotecardMnemonicRequest } from 'common/src/api/contentFrontendVsContentBackend/requests'
import { GenerateNotecardMnemonicResponse } from 'common/src/api/contentFrontendVsContentBackend/responses'

const PREFIX = CB_BASE_PREFIX + '/elasticSearch'
export const getCFPrimarySearchResults = async (
    searchText: string,
    searchContexts: SearchContext[],
    courseName?: string,
    cancelToken: CancelToken = null
): APIResponseWrapper<CFSearchResponse> => {
    return await callBackend<CBSearchRequest, CFSearchResponse>(
        PREFIX + '/getCFPrimarySearchResults',
        ApiMethod.GET,
        {
            searchText,
            searchContexts,
            courseName,
        },
        cancelToken
    )
}

export const findSimilarNotecards = async (
    questionText: string,
    solutionText: string,
    courseName: string,
    cancelToken: CancelToken = null
): APIResponseWrapper<FindSimilarNotecardsResponse> => {
    return await callBackend<
        FindSimilarNotecardsRequest,
        FindSimilarNotecardsResponse
    >(
        PREFIX + '/findSimilarNotecards',
        ApiMethod.POST,
        {
            questionText,
            solutionText,
            courseName,
        },
        cancelToken
    )
}

export const generateNotecardMnemonic = async (
    payload: {
        courseName: string
        notecardID: string
        guidance?: string
        fixedMnemonic?: string
    },
    cancelToken: CancelToken = null
): APIResponseWrapper<GenerateNotecardMnemonicResponse> => {
    return await callBackend<
        GenerateNotecardMnemonicRequest,
        GenerateNotecardMnemonicResponse
    >(
        PREFIX + '/generateNotecardMnemonic',
        ApiMethod.POST,
        {
            courseName: payload.courseName,
            id: payload.notecardID,
            ...(payload.guidance ? { guidance: payload.guidance } : {}),
            ...(payload.fixedMnemonic
                ? { fixedMnemonic: payload.fixedMnemonic }
                : {}),
        },
        cancelToken
    )
}
